import React, { useEffect, useRef } from "react";

export const DDiv = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<"div">
>(({ children, onDoubleClick, ...props }, refParam) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (typeof ref === "function") return;
    if (!ref || !ref.current) return;
    (ref.current as HTMLDivElement).ondragstart = (e) => e.preventDefault();
    const current = ref.current as HTMLDivElement;

    let lastTapTime = 0;
    const onTouchStart = (e: TouchEvent) => {
      const now = Date.now();
      if (now - lastTapTime < 300) {
        e.preventDefault();
        onDoubleClick?.(e as any);
      }
      lastTapTime = now;
    };

    const onDblclick = (e: MouseEvent) => {
      onDoubleClick?.(e as any);
    };

    current.addEventListener("touchstart", onTouchStart, { passive: false });
    current.addEventListener("dblclick", onDblclick);
    return () => {
      if (!ref || !ref.current) return;
      current.removeEventListener("touchstart", onTouchStart);
      current.removeEventListener("dblclick", onDblclick);
    };
  }, [ref]);

  return (
    <div ref={ref} {...props}>
      {children}
    </div>
  );
});
